import type { DeleteImpactMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useTRPC } from '@/utils/trpc';

export const useDeleteObligationImpactTRPC = () => {
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    ...trpc.frontend.obligationImpact.delete.mutationOptions({
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.obligationImpact.getByParentId.queryKey(),
        });
        // COI-471 parity: Apollo twin also evicts `obligation`.
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.obligation.pathKey(),
        });
      },
    }),
  });

  return {
    deleteObligationImpacts: async (variables: {
      ids: string[];
    }): Promise<DeleteImpactMutation> => {
      const result = await mutation.mutateAsync(variables);

      return mapTrpcResponseToGraphQL(result.affected_rows);
    },
    loading: mutation.isPending,
    error: mutation.error,
  };
};

function mapTrpcResponseToGraphQL(affectedRows: number): DeleteImpactMutation {
  return {
    delete_impact: {
      __typename: 'impact_mutation_response',
      affected_rows: affectedRows,
    },
  };
}
